import Trans from '../translations/trans';

const Price = ({ prices }) => {
    return (
        <div className='arc3-price --smaller'>
            <Trans transKey='product.startingAt' />
            <div className='arc3-margin arc3-no-margin--left arc3-no-margin--right'>
                {prices.isLowest30DaysPrice ? (
                    <div class='bottom-block'>
                        <p className='arc3-price__discounted'> {prices.discountedPrice}</p>
                        <div class='arc3-color-text-secondary'>
                            <p className='arc3-price__subtitle arc3-margin--right'>
                                <Trans transKey='product.lowest30DaysPrice' />
                            </p>
                            <p className='arc3-price__full'>{prices.strikeThroughPrice}</p>
                            <p class='arc3-price__percentage-discount'>{prices.discountLabel}</p>
                        </div>
                    </div>
                ) : (
                    <span>
                        {prices.discountedPrice ? (
                            <span>
                                <p className='arc3-price__full'>{prices.strikeThroughPrice}</p>
                                <p className='arc3-price__discounted'> {prices.discountedPrice}</p>
                            </span>
                        ) : (
                            <p className='arc3-price__discounted --dark-text'>{prices.strikeThroughPrice}</p>
                        )}
                        {prices.discountLabel ? (
                            <p class='arc3-price__percentage-discount'>{prices.discountLabel}</p>
                        ) : (
                            ''
                        )}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Price;
